<template>
    <div class="term-and-privacy">
        <el-dialog
            :visible.sync="dialogVisible"
            :width="dialogWidth"
            top="5vh"
            custom-class="term-dialog"
            @closed="dialogVisible = false"
        >
            <div class="dialog-content" v-if="lang == 'pt'">
                <!-- 标题 -->
                <h2 class="title">
                    Termos de Uso e Política de Privacidade da FOGO TV
                </h2>

                <!-- 条款内容 -->
                <div class="content">
                    <section>
                        <p>
                            Estes Termos de Uso correspondem à FOGO TV e seu
                            site correspondente, www.playfogotv.com. A FOGO TV
                            será mencionada como "FOGO" nos parágrafos
                            seguintes. Ao usar o serviço, você concorda com
                            estes "Termos de Uso e Política de Privacidade".
                        </p>
                        <i>Associação</i>
                        <p>
                            Qualquer indivíduo, registrado ou não, será
                            considerado um "usuário". Depois que o usuário criar
                            uma conta FOGO, o usuário será considerado um
                            "membro".
                        </p>
                        <p>
                            O usuário/membro reconhece e concorda que tanto o
                            serviço fornecido pela FOGO por meio de seu site e
                            aplicativos quanto as plataformas por meio das quais
                            tal serviço é fornecido (aplicativos de TV box,
                            aplicativos móveis, redes de mídia social e
                            programas para download) são de propriedade
                            exclusiva da FOGO.
                        </p>
                        <p>
                            A seu critério, a FOGO pode oferecer serviços e/ou
                            produtos on-line adicionais, ou atualizar, modificar
                            ou revisar quaisquer serviços e/ou produtos atuais.
                            Este acordo se aplicará a todos e quaisquer serviços
                            e/ou produtos adicionais e a todos e quaisquer
                            serviços e/ou produtos atualizados, modificados ou
                            revisados, a menos que estipulado de outra forma. A
                            FOGO reserva-se o direito de cancelar e deixar de
                            oferecer qualquer um dos serviços e/ou produtos
                            acima mencionados. O usuário/membro reconhece,
                            aceita e concorda que a FOGO não será responsável
                            por quaisquer atualizações, modificações, revisões,
                            interrupções ou descontinuações de quaisquer e todos
                            os nossos serviços e/ou produtos. O uso contínuo do
                            serviço após atualizações, alterações e/ou
                            modificações terem sido aplicadas significa que o
                            usuário/membro aceita tais atualizações, alterações
                            e/ou modificações. Limitações de responsabilidades.
                            O usuário/membro entende, reconhece e concorda que o
                            serviço será fornecido "como está". Além disso, a
                            FOGO não será responsável por impedimentos e/ou
                            entrega perdida em relação aos canais de comunicação
                            e exclusão e/ou perda de conteúdo do usuário ou
                            personalização de configurações.
                        </p>
                        <i>Teste grátis</i>
                        <p>
                            Para acessar o serviço, o usuário/membro deve baixar
                            o APK e instalá-lo no dispositivo correspondente,
                            como Android TV box ou smartphone, conforme
                            aplicável.
                        </p>
                        <p>
                            A FOGO oferece um teste grátis de 7 dias para novos
                            usuários/membros. Este teste grátis de 3 dias é
                            exclusivo para novos usuários/membros. Após esse
                            período, o usuário receberá um lembrete para renovar
                            o serviço. Assim que o teste grátis terminar, os
                            usuários/membros terão que adquirir um plano para
                            continuar aproveitando o serviço. Na medida
                            permitida pela lei aplicável, os pagamentos não são
                            reembolsáveis. O usuário/membro receberá um código
                            online para renovar o serviço.
                        </p>
                        <i>Registro</i>
                        <p>
                            Informações pessoais: Para se registrar na FOGO,
                            seja por meio de site ou aplicativo, o usuário deve
                            ter pelo menos 18 anos. Após o registro, a FOGO pode
                            coletar informações como nome da conta, endereço de
                            e-mail e outras informações relacionadas. O
                            usuário/membro poderá editar as informações da conta
                            a qualquer momento.
                        </p>
                        <p>
                            Segurança: A prioridade da FOGO é garantir a
                            segurança e a privacidade de todos os usuários e
                            membros, especialmente os menores. Portanto, é
                            responsabilidade dos pais/responsáveis legais
                            controlar, restringir e/ou garantir que o conteúdo
                            que seu menor acessa no site e/ou plataforma da FOGO
                            seja apropriado para sua idade.
                        </p>
                        <p>
                            Segurança da conta de membro Depois que os usuários
                            se tornam membros, eles são os únicos usuários
                            autorizados de suas contas ("Proprietário da
                            conta"). O Proprietário da conta será responsável
                            por não revelar a senha ou atividades relacionadas à
                            conta a ninguém. Caso contrário, o Proprietário da
                            conta estará violando estes Termos de uso. O
                            Proprietário da conta notificará a FOGO
                            imediatamente sobre qualquer acesso não autorizado
                            ou qualquer outra violação de segurança. A FOGO não
                            será responsável por qualquer perda ou dano
                            decorrente de qualquer falha em cumprir os termos
                            e/ou condições aqui contidos.
                        </p>
                        <p>
                            Uso e armazenamento de dados: O usuário/membro
                            reconhece que a FOGO pode estabelecer práticas a
                            critério da FOGO em relação ao uso do serviço, como
                            número máximo de vezes e/ou duração que um
                            usuário/membro acessa nosso serviço em um
                            determinado período de tempo, número máximo de
                            mensagens de e-mail que podem ser enviadas e/ou
                            recebidas via FOGO, espaço máximo de disco permitido
                            armazenado no servidor da FOGO. Além disso, o
                            usuário/membro concorda que a FOGO não é responsável
                            pela remoção de qualquer e-mail, mensagem, postagem
                            ou informação carregada do usuário/membro que exceda
                            o número máximo de dias de armazenamento. Além
                            disso, o usuário/membro reconhece que a FOGO
                            reserva-se o direito de excluir ou remover qualquer
                            conta que não tenha sido ativa pelo período máximo
                            de tempo estendido. Além disso, a FOGO reserva-se o
                            direito de modificar, alterar e/ou atualizar essas
                            práticas e limites gerais quando julgar necessário.
                        </p>
                        <p>
                            Conformidade com as Regras e Regulamentos Locais da
                            Internet: Devido ao escopo global da Internet, ao
                            usar nosso serviço, o usuário/membro concorda em
                            cumprir todas as regras locais relacionadas ao
                            comportamento online e ao conteúdo considerado
                            aceitável. Assim, ao acessar nosso serviço, o
                            usuário/membro concorda em não usar ou compartilhar
                            nenhum software, tecnologia e outros dados técnicos
                            para países onde essas ações não são permitidas.
                            Caso contrário, o usuário/membro será o único
                            responsável pelas consequências que possam surgir.
                        </p>
                        <p>
                            Aviso Legal: A FOGO reserva-se o direito de, a
                            qualquer momento que julgar conveniente, modificar,
                            alterar e/ou interromper, temporária ou
                            permanentemente, o serviço ou qualquer seção dele
                            com ou sem aviso prévio. Além disso, a FOGO não será
                            responsável pelas consequências decorrentes dessas
                            ações.
                        </p>
                        <p>
                            Termos de Uso e Política de Privacidade: A FOGO
                            reserva-se o direito, a seu exclusivo critério, de
                            alterar, modificar, adicionar ou remover seções
                            destes Termos de Uso a qualquer momento. É
                            responsabilidade do usuário/membro revisar estes
                            Termos de Uso de tempos em tempos. Portanto, o
                            usuário/membro deve revisar frequentemente estes
                            Termos de Uso e todos os termos e políticas
                            aplicáveis para garantir que o usuário/membro esteja
                            ciente de todos os termos e políticas atualmente em
                            vigor. O uso contínuo do serviço após as alterações
                            terem sido aplicadas significa que o usuário aceita
                            e concorda com as alterações.
                        </p>
                        <p>Condições de assinatura</p>
                        <p>
                            Você pode usar este produto ou este serviço durante
                            a duração da sua assinatura. A duração da
                            assinatura, o período de cobrança e o preço por
                            período de assinatura para cada produto serão
                            exibidos durante o processo de pedido.
                        </p>
                        <p>
                            O preço promocional não será aplicado ao preço da
                            assinatura.
                        </p>
                        <p>
                            Copyright©2026 FOGO TV Team. Todos os direitos
                            reservados.
                        </p>
                        <p>Entre em contato conosco: fogotv4k@gmail.com.</p>
                    </section>
                </div>
            </div>
            <div class="dialog-content" v-else>
                <!-- 标题 -->
                <h2 class="title">FOGO TV Term Of Use and Privacy Policy</h2>

                <!-- 条款内容 -->
                <div class="content">
                    <section>
                        <p>
                            These Terms of Use correspond to FOGO TV and its
                            corresponding website,www.playfogotv.com.FOGO TV
                            will be mentioned as"FOGO"in the following
                            paragraphs.By using the service,you agree to
                            this"Terms of Use & Privacy Policy".
                        </p>
                        <i>Membership</i>
                        <p>
                            Any individual,either registered or not,shall be
                            considered a"user".Once the user creates a FOGO
                            account,the user shall then be considered a"member".
                        </p>
                        <p>
                            The user/member acknowledges and agrees that both
                            the service provided by FOGO via its website and
                            apps and the platforms by means of which such
                            service is provided(TV box apps,mobile apps,social
                            media networks and downloadable programs)are the
                            sole property of FOGO.
                        </p>
                        <p>
                            At its discretion,FOGO may offer additional online
                            services and/or products,or update,modify or revise
                            any current services and/or products.This agreement
                            shall apply to any and all additional services
                            and/or products and any and all updated,modified or
                            revised services and/or products unless otherwise
                            stipulated.FOGO hereby reserves the right to cancel
                            and cease offering any of the aforementioned
                            services and/or products.The user/member
                            acknowledges,accepts and agrees that FOGO shall not
                            be liable for any such
                            updates,modifications,revisions,interruptions or
                            discontinuances of any and all of our services
                            and/or products.The continued use of the service
                            after updates,changes and/or modifications have been
                            applied mean that the user/member accepts such
                            updates,changes,and/or modifications.Limitations on
                            liabilities.The user/member understands,acknowledges
                            and agrees that the service shall be provided“as
                            is”.Furthermore,FOGO shall not be liable for
                            hindrances and/or missed delivery regarding
                            communication channels and deletion and/or loss of
                            user’s content or settings customization.
                        </p>
                        <i>Free-trial</i>
                        <p>
                            In order to access the service,the user/member
                            should download the APK and install it in the
                            corresponding device,such as Android TV box or
                            smartphone,as applicable.
                        </p>
                        <p>
                            FOGO offers a 7-day free-trial for new
                            users/members.This 3-day free-trial is exclusive for
                            new users/members.After that period of time,the user
                            shall get a reminder to renew the service.Once the
                            free-trial finishes,users/members will have to
                            acquire a plan to continue enjoying the service.To
                            the extent permitted by the applicable law,payments
                            are non-refundable.The user/member will receive an
                            online code to renew the service.
                        </p>
                        <i>Registration</i>
                        <p>
                            Personal information:To register on FOGO,whereas it
                            is via website or app,the user must be at least 18
                            years old.After registration,FOGO may collect
                            information such as account name,email address and
                            other related information.The user/member will be
                            able to edit the account information at any time.
                        </p>
                        <p>
                            Security:FOGO's priority is to ensure the safety and
                            privacy of all users and members, especially that of
                            minors. Thus, it is the parent's/legal guardian's
                            responsibility to control, restrict and/or make sure
                            that the content their minor accesses in the FOGO
                            website and/or platform is appropriate for their
                            age.
                        </p>
                        <p>
                            Member Account Security Once users become members,
                            they are the sole authorized users of their accounts
                            ("Account Owner"). The Account Owner shall be
                            responsible of not revealing the password or
                            activities related to the account to anyone.
                            Otherwise, the Account Owner will be violating these
                            Terms of Use. The Account Owner shall notify FOGO
                            immediately about any unauthorized access or any
                            other breach of security. FOGO shall not be liable
                            for any loss or damage arising from any failure to
                            comply with the terms and/or conditions contained
                            herein.
                        </p>
                        <p>
                            Data Usage and Storage: The user/member hereby
                            acknowledges that FOGO may set up practices at
                            FOGO's discretion regarding the use of the
                            service,such as maximum number of times and/or
                            duration that a user/member accesses our service in
                            a given period of time,maximum number of email
                            messages that may be sent and/or received via
                            FOGO,maximum allowable disc space stored in FOGO's
                            server. In addition, the user/member agrees that
                            FOGO is not liable for removal of any
                            user's/member's email, message, post or uploaded
                            information whatsoever that exceeds the maximum
                            number of days of storage. Plus, the user/member
                            acknowledges that FOGO reserves the right to delete
                            or remove any account that has not been active for
                            the maximum extended period of time. Furthermore,
                            FOGO shall reserve the right to modify, alter and/or
                            update these general practices and limits when
                            deemed necessary.
                        </p>
                        <p>
                            Compliance with Internet Local Rules and
                            Regulations: Due to the global scope of the
                            Internet, by using our service, the user/member
                            hereby agrees to comply with all local rules related
                            to online behavior and the content considered
                            acceptable. Thus, by accessing our service, the
                            user/member agrees not to use or share any software,
                            technology and other technical data to countries
                            where these actions are not allowed. Otherwise, the
                            user/member will be solely responsible for the
                            consequences that may arise.
                        </p>
                        <p>
                            Disclaimer: FOGO shall reserve the right at any time
                            it may deem convenient to modify, alter and/or
                            interrupt, whether temporarily or permanently, the
                            service or any section thereof with or without prior
                            notice. In addition, FOGO shall not be liable for
                            the consequences deriving from these actions.
                        </p>
                        <p>
                            Terms of Use & Privacy Policy: FOGO shall reserve
                            the right, at its sole discretion, to change,
                            modify, add or remove sections of these Terms of Use
                            at any time. It is the user's/member's
                            responsibility to revise these Terms of Use from
                            time to time. Thus, the user/member should
                            frequently review these Terms of Use and all the
                            applicable terms and policies to ensure the
                            user's/member's awareness of all terms and policies
                            currently in effect.The continued use of the service
                            after changes have been applied shall mean that the
                            user accepts and agrees to the changes.
                        </p>
                        <p>Subscription Conditions</p>
                        <p>
                            You can use this product or this service for the
                            duration of your subscription.The duration of the
                            subscription,the billing period,and the price per
                            subscription period for each product will be
                            displayed during the order process.
                        </p>
                        <p>
                            Promotion price will not be applied to the
                            subscription price.
                        </p>
                        <p>Copyright©2025 FOGO TV Team.All rights reserved.</p>
                        <p>Contact us: fogotv4k@gmail.com.</p>
                    </section>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    size="medium"
                    @click="dialogVisible = false"
                >
                    OK
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            // 响应式宽度
            dialogWidth: '50%'
        }
    },
    mounted() {
        this.setResponsive()
        window.addEventListener('resize', this.setResponsive)
    },
    computed: {
        lang() {
            return this.$i18n.locale
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setResponsive)
    },
    methods: {
        setResponsive() {
            this.dialogWidth = window.innerWidth < 768 ? '90%' : '50%'
        },
        open() {
            this.dialogVisible = true
        }
    }
}
</script>
  
<style scoped>
.term-dialog {
    border-radius: 8px;
}
.term-dialog .el-dialog__header {
    display: none !important;
}
.dialog-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
}

.title {
    color: #2c3e50;
    text-align: center;
    margin-bottom: 20px;
    font-size: clamp(1.2rem, 2vw, 1.5rem);
}

h3 {
    color: #34495e;
    margin: 15px 0;
    font-size: 1.1rem;
}

ul {
    padding-left: 20px;
    line-height: 1.6;
}

li {
    margin: 8px 0;
    font-size: 0.95rem;
}

.actions {
    text-align: center;
    margin-top: 25px;
}

@media (max-width: 768px) {
    .term-dialog {
        margin: 10px !important;
    }

    li {
        font-size: 0.85rem;
    }

    .el-button {
        width: 100%;
        padding: 12px;
    }
}
</style>